import React from 'react';
import { getRegionBySeriesId } from '@mentimeter/region';
import { useUser } from '@mentimeter/user';
import {
  getAuthCallback,
  usePresentationRealtimeSetup,
} from '@mentimeter/realtime';
import { useAblyConfig } from 'lib/realtime/useAblyConfig';
import {
  isAcademyPresentation,
  isExamplePresentation,
} from 'features/core/presentation/shared/examplePresentation';
import { core } from '@mentimeter/http-clients';
const ENABLE_REALTIME_PUBLISH_DD_METRICS =
  (process.env.NEXT_PUBLIC_ENABLE_REALTIME_PUBLISH_DD_METRICS as
    | 'true'
    | 'false'
    | undefined) ?? 'false';

export const useRealtime = (seriesId: string, forceInit?: boolean) => {
  const { isAuthenticated, user } = useUser();
  const isExample = isExamplePresentation(seriesId);
  const isAcademy = isAcademyPresentation(seriesId);
  const shouldInit = Boolean(
    isAuthenticated || isExample || isAcademy || forceInit,
  );
  const userRegion = user?.region;
  const seriesRegion = getRegionBySeriesId(seriesId);
  const conflictingRegions =
    userRegion && seriesRegion && userRegion !== seriesRegion;
  const clientId =
    user?.id && !conflictingRegions ? String(user?.id) : 'unknown';

  const authCallback = React.useMemo(
    () =>
      getAuthCallback(async () => {
        const { data: token } = await core({
          region: seriesRegion,
        }).series.realtime(seriesId);
        return token;
      }),
    [seriesId, seriesRegion],
  );
  const presentationAblyConfig = useAblyConfig({
    clientId,
    authCallback,
  });
  return usePresentationRealtimeSetup({
    ablyConfig: presentationAblyConfig,
    shouldInit,
    enableRealtimePublishDDMetricsEnvVar: ENABLE_REALTIME_PUBLISH_DD_METRICS,
  });
};
